import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type AccessTokensStore } from 'pages/settings/pages/developer/pages/accessTokens/store/accessTokensStore'

type INewTokenModalActionsProps = {
  store: AccessTokensStore
}

export const NewTokenModalActions = observer(({ store }: INewTokenModalActionsProps) => {
  if (store.createdTokenResponse) {
    return null
  }

  return (
    <Button
      typeBtn='contained'
      text={store.newTokenModalSaving ? 'Creating' : 'Create'}
      size='medium'
      disabled={!store.isNewTokenFormValid || store.newTokenModalSaving}
      loading={store.newTokenModalSaving}
      onClick={store.handleCreateToken}
    />
  )
})
